import React from 'react';
import { Card } from "react-bootstrap";
import face_botond_szilagyi from "../../assets/img/9.png";
import ShowMoreText from "react-show-more-text";
import proj_mirror_modeling from "../../assets/img/proj_mirror_modeling.png";

const Botond_Szilagyi_mirror_modeling = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_mirror_modeling} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_botond_szilagyi}
              /* this will be the text on the banner */
              alt="Mirror modeling: a direct approach to model parameter estimation using machine learning"
            />{" "}
            <p className="text7">Botond Szilágyi</p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            <p className="text8">Department of Chemical and Environmental Process Engineering, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Process models are widely used in chemical and pharmaceutical manufacturing to understand, 
            design, and control processes more safely and cleanly. These models usually translate to 
            ordinary or partial differential equations, which provide the temporal evolution of the 
            variables of interest (reactor temperature, conversion, pressure, etc.). The ability to 
            predict these variables gives immense power to the engineers as now the real, often highly 
            toxic and/or expensive experiments can be replaced with computer simulations confidently. 
            The devil is in the details, though. The mathematical description of, e.g., hydrogen burning 
            (immensely rapid reaction, explosion) and the formation of diamond from carbon (a prolonged 
            reaction, unfortunately) is described with the same or very similar differential equations. 
            The major difference is in the values of the kinetic rate parameters. Traditionally, these 
            parameters are obtained by solving a reverse problem (i.e., asking the question that what 
            should be the values of the model parameters to ensure that the simulations are as close to 
            the measurements as possible). Solving this optimization may sometimes be extremely challenging, 
            which is probably the most significant bottleneck in the model-based design workflow. Our goal 
            is to test and extend the landscape of the mirror-model concept (Raponi & Marchisio, 2024) for 
            various processes (chemical reactions and crystallizations) using synthetic experimental data, 
            which has the advantage that the exact solution is known. The mirror-model will be compared 
            with the traditional, optimization-based parameter identification in terms of nominal fit and 
            parameter confidence intervals.

            <br />
            <br />
            Recommended literature:
            <ul>
                <li>
                Raponi, A., & Marchisio, D. (2024). Deep learning for kinetics parameters identification: 
                A novel approach for multi-variate optimization. Chemical Engineering Journal, 489, 151149.
                <a href="https://doi.org/10.1016/j.cej.2024.151149">https://doi.org/10.1016/j.cej.2024.151149</a>
                </li>
            </ul>


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Botond_Szilagyi_mirror_modeling;